module.exports = __webpack_public_path__ + "img/logo-amazon.eabaa4d1.webp";